export default "__VITE_ASSET__BOXCekFy__"